// frontend/src/services/avatars.js

// Rutas actualizadas con los nombres de archivo originales que descargaste.
export const defaultAvatars = [
  '/avatars/arcade-svgrepo-com.svg',
  '/avatars/basket-svgrepo-com.svg',
  '/avatars/bean-svgrepo-com.svg',
  '/avatars/bee-svgrepo-com.svg',
  '/avatars/fear-svgrepo-com.svg',
  '/avatars/knight-svgrepo-com.svg',
  '/avatars/monkey-silent-svgrepo-com.svg',
  '/avatars/pig-svgrepo-com.svg',
  '/avatars/planets-svgrepo-com.svg',
  '/avatars/predator-svgrepo-com.svg',
  '/avatars/shit-sunglasses-svgrepo-com.svg',
  '/avatars/short-hair-svgrepo-com.svg',
  '/avatars/student-female-svgrepo-com.svg',
  '/avatars/topview-svgrepo-com.svg',
  '/avatars/vision-jew-svgrepo-com.svg',
  '/avatars/walle-female-svgrepo-com.svg',
];